// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__t6oaD","subText":"SuccessPage_subText__YwARN"};